<template>
  <div class="hint">
    <p><strong v-if="title">{{ title }}: </strong><slot></slot></p>
  </div>
</template>

<style scoped>
.hint {
  margin: 1.75rem 0;
  padding: 1.25em 1.6667em;
  border-radius: var(--inputBorderRadius);
  background-color: var(--magnolia);
  font-size: 1rem;
  line-height: 1.5;
}
</style>
<script>
export default {
  name: "Hint",
  props: ["title"]
}
</script>